
import { Vue, Component } from 'vue-property-decorator';
import { Tree, Button, Tooltip } from 'element-ui';
import api from '@/api/course';
import bModal from './components/bModal.vue';

@Component({
  components: {
    Tree,
    Button,
    bModal,
    Tooltip,
  },
})
export default class courseType extends Vue {
  private data:any = [];

  private visible: boolean = false;

  private title: string = '';

  private form: any = [];

  private defaultExpand: any = ['0'];

  private parentId: string = '';

  private dragTypeDisable: boolean = true;

  private dragTypeloading: boolean = false;

  mounted() {
    this.getData();
  }

  getData() {
    this.defaultExpand = ['0'];
    if (this.parentId) this.defaultExpand.push(this.parentId);
    api.getType().then((res: any) => {
      this.data = res;
    });
  }

  handleAdd(data:any) {
    this.visible = true;
    this.title = '添加课程分类';
    this.form.parentId = data.id;
    this.parentId = data.id;
  }

  handelEdit(data:any) {
    this.visible = true;
    this.title = '修改课程分类';
    this.form = data;
  }

  // 拖动分类结束
  dragEnd() {
    this.dragTypeDisable = false;
  }

  preorderTraversal(node: any, result: any) {
    if (!node) return;
    const stack: any = [];
    stack.push(node);
    while (stack.length > 0) {
      let item: any = [];
      item = stack.pop();
      const childen = item.children;
      if (childen) {
        childen.forEach((e: any) => {
          stack.push(e)
          result.push({ id: e.id, pid: item.id });
        });
      }
    }
  }

  SaveDragType() {
    const result = [];
    if (!this.data || this.data.length === 0) return
    this.data.forEach((e: any) => this.preorderTraversal(e, result))
    this.dragTypeloading = true;
    api.updataCourseType(result).then((res: any) => {
      this.dragTypeDisable = true;
      this.dragTypeloading = false;
    }).catch(() => {
      this.dragTypeDisable = true;
      this.dragTypeloading = false;
    });
  }
}
